module.exports = __webpack_public_path__ + "img/dom-carlos-liberty.e45bddae.jpg";